import { camelizeKeys } from "humps"
import { DioboxEvent } from "sharedTypes"

export enum GuestStatus {
  Unconfirmed = 0,
  Confirmed = 1,
  Declined = 2,
  Waitlisted = 3,
}

export interface IGuest {
  id: string
  name: string
  email: string
  qrCodeUrl: string
  status: GuestStatus
  unsubscribed: boolean
  event: DioboxEvent
  activities: {}[]
  checkedIn: boolean
  expiringQrCodes: boolean
}

// @ts-ignore
const camelizeResponseBody = (object: any): {} => camelizeKeys(object, (key, convert, _, path) => (path.includes("responses") ? key : convert(key)))

const doGet = async (url: string) => {
  const res = await fetch(url, { cache: "no-store" })
  try {
    return res.ok ? camelizeResponseBody(await res.json()) : null
  } catch (e) {
    return null
  }
}

export const getPublicGuest = async (id: string): Promise<IGuest | null> => {
  const res = doGet(
    `${process.env.NEXT_PUBLIC_API_BASE}/api/v3/public/guests/${id}`,
  )

  return res ? (res as Promise<IGuest>) : null
}

export default getPublicGuest
